import React, { useEffect } from 'react';

import styles from '../../theme/staticpages.module.scss';
import '../../theme/global.scss';
import { Space } from '../../components/utils/utils';
import { variables } from '../../utils/variables';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className={styles.containerStaticPage}>
      <div className={styles.steps}>
        <p className='bold'>
          POLITICA DE CONFIDENTIALITATE A SOFTWARE-ULUI SIRAR
        </p>
        <Space vertical={variables.verticalSpace} />

        <p>
          <b>Versiunea [1]</b>
          <br></br>
          <b>Data ultime actualizari: [10.12.2021]</b>
        </p>
        <Space vertical={variables.verticalSpace} />

        <ol type='I'>
          <li>
            <p>
              <b>CINE SUNTEM</b>
            </p>
            <ol type='1'>
              <p>
                <li>
                  Suntem SIRAR SOLUTIONS S.R.L., societate de drept roman cu
                  sediul in Municipiul Târgovişte, Str. G-RAL MATEI VLĂDESCU,
                  Nr. 1, Bloc 18, Etaj 2, Apartament 12, Județ Dâmboviţa, avand
                  numar de inregistrare J15/346/2021, identificator unic
                  european, ROONRC.J15/346/2021, CUI 43852251 (denumita in cele
                  ce urmeaza “<b>noi</b>”, „<b>Societatea</b>” sau orice alt
                  termen similar).
                </li>
              </p>
              <p>
                <li>
                  Am creat si dezvoltat software-ul Sirar® (denumit in cele ce
                  urmeaza „<b>Software-ul</b>” sau “<b>Sirar</b>”) avand ca
                  funcționalitati principale monitorizarea de catre instituțiile
                  publice inrolate in platforma Sirar („
                  <b>Instititutiile publice</b>” sau „<b>Utilizatorii</b>” sau „
                  <b>dvs.</b>”) a implementarii masurilor dispuse sau
                  recomandate (“<b>Masurile de remediere</b>”) de catre organele
                  de audit si/sau control competente, in urma inspectiilor
                  efectuate la asemenea institutii publice, precum si
                  monitorizarea stadiului dosarelor de instanta prin interogarea
                  portalului <a href='http://www.just.ro'>www.just.ro</a>
                </li>
              </p>
              <p>
                <li>Software-ul poate fi accesat la adresa [...]. </li>
              </p>
              <p>
                <li>
                  Prin intermediul Software-ului, conducatorii Institutiilor
                  publice, inclusiv conducatorii autoritatilor ierarhic
                  superioare, isi pot forma o imagine transparenta si sintetica
                  asupra Masurilor de remediere, inclusiv asupra gradului si
                  stadiului implementarii acestora de catre persoanele
                  responsabile, ca si asupra respectarii termenelor-limita
                  impuse, acolo unde este cazul.
                </li>
              </p>
              <p>
                <li>
                  In afara punerii la dispozitie a Software-ului, Societatea nu
                  presteaza alte tipuri de servicii prin intermediul
                  Software-ului; in mod particular, nu poate fi tinuta
                  responsabila pentru activitatea Institutiilor sau a
                  persoanelor autorizate de catre acestea prin intermediul
                  Software-ului sau in alte circumstante.
                </li>
              </p>
              <p>
                <li>
                  Daca doriti sa luati legatura cu noi, ne puteti transmite un
                  email la adresa office@sirar.ro sau ne puteti scrie la adresa
                  de sediu.
                </li>
              </p>
            </ol>
          </li>

          <li>
            <p>
              <b>
                RELATIA NOASTRA CU UTILIZATORII SOFTWARE-ULUI SI DATELE
                PERSONALE PRELUCRATE
              </b>
            </p>
            <ol type='1'>
              <p>
                <li value='7'>
                  Prin intermediul Software-ului colectam, stocam, transferam si
                  utilizam diverse date cu caracter personal (denumite si „
                  <b>date personale</b>” sau „<b>DCP</b>”), acestea fiind
                  operatiuni de prelucrare de date cu caracter personal,
                  potrivit dispozitiilor Regulamentului General privind
                  protectia datelor cu caracter personal sau GDPR (denumite in
                  mod colectiv “<b>prelucrari</b>” sau “
                  <b>operatiuni de prelucrare</b>”).{' '}
                </li>
              </p>
              <p>
                <li>
                  Potrivit GDPR, datele personale includ orice informatii
                  privind o persoana fizica identificata sau identificabila
                  (denumita in continuare „<b>Persoana Vizata</b>”).
                </li>
              </p>
              <p>
                <li>
                  Operatiunile de prelucrare le realizam, in cea mai mare parte,
                  in numele si pe seama Utilizatorilor si la instructiunile
                  acestora. Noi actionam astfel in calitate de persoana
                  imputernicita sa prelucreze date cu caracter personal („
                  <b>Imputernicit</b>”). In acest sens, Software-ul reprezinta
                  un instrument de optimizare a activitatii Institutiilor
                  publice, Utilizatorii fiind cei care directioneaza prelucrarea
                  datelor in nume propriu si pentru scopurile determinate de
                  acestia (in principal, urmarirea implementarii Masurilor de
                  remediere, urmarirea stadiului dosarelor in instanta prin
                  intermediul portalului just.ro).{' '}
                </li>
              </p>
              <p>
                <li>
                  De asemenea, prelucram date personale in nume propriu, pentru
                  scopuri proprii descrise mai jos, in calitate de operator de
                  date cu caracter personal independent (“<b>Operator</b>”).
                </li>
              </p>
              <p>
                <li>
                  Pentru reglementarea acestor prelucrari si prezentarea lor in
                  mod transparent catre Persoanele Vizate, am adoptat aceasta
                  Politica de confidentialitate (“<b>Politica</b>”), pe care va
                  incurajam sa o cititi cu atentie. Va punem in vedere ca ea nu
                  aduce atingere sau inlatura orice drepturi pe care vi le
                  acorda in mod imperativ legislatia aplicabila.
                </li>
              </p>
              <p>
                <li>
                  Pentru evitarea oricarui dubiu, aceasta Politica nu
                  reglementeaza prelucrarile de date personale pe care le
                  realizam prin intermediul website-ului
                  <a className='regularA' href='http://www.sirar.ro'>
                    www.sirar.ro
                  </a>
                  . Aceste sunt reglementate de o politica de confidentialitate
                  distincta pe care o regasiti la link-ul
                  <a href='#'>Politica confidentialitate!!!</a>
                </li>
              </p>
            </ol>
          </li>
          <li>
            <p>
              <b>PRELUCRARILE NOASTRE IN CALITATE DE IMPUTERNICIT</b>
            </p>
            <i>III.1. Categoriile de date personale si contextul prelucrarii</i>
            <ol>
              <p>
                <li value='13'>
                  Mai jos sunt mentionate categoriile de informatii, inclusiv
                  datele personale, pe care dvs., le introduceti sau le faceti
                  accesibile in cadrul platformei Sirar („
                  <b>Date generate de Utilizator</b>” sau „
                  <b>Datele generate de dvs.</b>”), pentru a beneficia de
                  functionalitatile acesteia (cu exceptia datelor pe care ni le
                  furnizati spre prelucrare conform sectiunii IV din aceasta
                  Politica).{' '}
                </li>
              </p>
              <ol type='a'>
                <p>
                  <li>
                    Datele referitoare la reprezentantii persoane fizice ale
                    Utilizatorilor – acestea pot include: nume, prenume, adresa
                    de e-mail, alte date de identificare.
                  </li>
                </p>
                <p>
                  <li>
                    La datele de mai sus se adauga si o serie de informatii si
                    date, inclusiv date personale, care va permit utilizarea
                    Software-ului sau care au legatura cu aceasta (cum ar fi
                    informatiile cuprinse in rapoartele de audit sau rapoartele
                    de control ale Curtii de Conturi).
                  </li>
                </p>
              </ol>
              <p>
                <li>
                  Datele generate de Utilizator sunt stocate in mod criptat,
                  intr-un mediu securizat oferit de un furnizor de servicii de
                  stocare in cloud. Ele nu sunt accesibile in clar de catre
                  nicio terta parte, folosind mijloace tehnologice obisnuite.{' '}
                </li>
              </p>
              <p>
                <li>
                  Societatea, prin reprezentantii sai autorizati, poate avea
                  acces la Datele generate de Utilizator, cu ocazia efectuarii
                  activitatilor sale de intretinere si mentenanta asupra
                  Software-ului sau la solicitarea expresa a sau cu autorizarea
                  Utilizatorului interesat. De asemenea, Societatea mai poate
                  oferi acces la Datele generate de Utilizator autoritatilor
                  competente, in conditiile legii.{' '}
                </li>
              </p>
              <p>
                <li>
                  Sub rezerva celor de mai sus si a respectarii Termenilor si
                  Conditiilor de utilizare a Software-ului (link), doar dvs.
                  veti avea acces si control asupra Datelor generate de dvs.
                  (e.g. puteti alege sa le introduceti, stergeti, modificati, sa
                  limitati accesul etc. la orice moment).{' '}
                </li>
              </p>
            </ol>
            <i>III.2. Acordul de prelucrare a datelor cu caracter personal</i>
            <ol type='1'>
              <p>
                <li value='17'>
                  Pentru realizarea prelucrarilor in calitate de Imputernicit al
                  dvs., Societatea isi asuma angajamentul de prelucrare a
                  datelor personale pe care il regasiti la urmatorul link. In
                  scopul acestor prelucrari aplicam Acordul de prelucrare a
                  datelor personale publicat disponibil la adresa URL (...) .
                </li>
              </p>
              <p>
                <li>
                  Prin crearea contului de utilizator in cadrul Software-ului,
                  Utilizatorii accepta sa devina parte a Acordului de prelucrare
                  a datelor cu caracter personal disponibil, din timp in timp,
                  pe website-ul <a href='www.sirar.ro'>www.sirar.ro</a>, care
                  reglementeaza prelucrarile noastre in calitate de
                  Imputernicit.
                </li>
              </p>
            </ol>
            <br></br>
          </li>
          <li>
            <p>
              <b>PRELUCRARILE NOASTRE IN CALITATE DE OPERATOR</b>
            </p>
            <i>IV.1. Continutul acestei sectiuni</i>
            <ol type='1'>
              <p>
                <li value='19'>
                  In aceasta sectiune IV, sunt mentionate informatii cu privire
                  la aspecte importante ale prelucrarilor de date personale,
                  efectuate de Societate in calitate de Operator.{' '}
                </li>
              </p>
              <p>
                <li>Aceste informatii includ:</li>
              </p>
              <ol type='a'>
                <p>
                  <li>
                    Contextul general al prelucrarilor, ce tip de date personale
                    sau alte informatii prelucram prin intermediul
                    Software-ului, precum si scopurile pentru care sunt
                    realizate aceste prelucrari (sub-sectiunea IV.2 si urm);
                  </li>
                </p>
                <p>
                  <li>
                    Catre cine dezvaluim aceste date, daca este cazul
                    (sub-sectiunea IV.7 si urm.)ꓼ
                  </li>
                </p>
                <p>
                  <li>
                    Transferul international de date cu caracter personal, daca
                    este cazul (sub-sectiunea IV.8);
                  </li>
                </p>
                <p>
                  <li>
                    Procesele decizionale automate privind datele cu caracter
                    personal, daca exista (sub-sectiunea IV.9);
                  </li>
                </p>
                <p>
                  <li>
                    Care sunt drepturile pe care le aveti in legatura cu aceste
                    date si cum le puteti exercita (sub-sectiunea IV.10)ꓼ
                  </li>
                </p>
                <p>
                  <li>
                    Alte informatii obligatorii potrivit REGULAMENTULUI (UE)
                    2016/679 AL PARLAMENTULUI EUROPEAN SI AL CONSILIULUI din 27
                    aprilie 2016 privind protectia persoanelor fizice in ceea ce
                    priveste prelucrarea datelor cu caracter personal si privind
                    libera circulatie a acestor date si de abrogare a Directivei
                    95/46/CE (”<b>GDPR</b>”) (sub-sectiunea IV.11).
                  </li>
                </p>
              </ol>
            </ol>
            <i>IV.2. Contextul prelucrarilor in calitate de Operator</i>
            <ol type='1'>
              <p>
                <li value='21'>
                  Pentru a putea beneficia de serviciile asigurate prin
                  Software, este necesara crearea unui cont de utilizator. Dupa
                  semnarea contractului furnizare servicii („
                  <b>Contractul de furnizare a Software-ului</b>”) prin care
                  primiti dreptul de utilizare si accesul la Software, noi vom
                  crea un cont de utilizator, folosind datele de contact pe care
                  ni le-ati pus la dispozitie. Ulterior, veti fi contactat
                  pentru activarea contului si inceperea folosirii sale.
                </li>
              </p>
              <p>
                <li>
                  Pentru crearea contului de Utilizator va solicitam o serie de
                  date, ce pot include date personale, pe care le prelucram in
                  calitate de operator.
                </li>
              </p>
              <table>
                <tr>
                  <th>
                    <b>
                      Informatii prelucrate de SIRAR ce pot include date
                      personale
                    </b>
                  </th>
                  <th>
                    <b>Scopurile prelucrarii</b>
                  </th>
                </tr>
                <tr>
                  <td>
                    <ol>
                      <p>
                        <li>
                          E-mailul de contact si parola, alte date de contact{' '}
                        </li>
                      </p>
                    </ol>
                  </td>
                  <td>
                    Pentru crearea contului de Utilizator si accesarea
                    serviciilor prestate prin intermediul Software-ului.
                  </td>
                </tr>
                <tr>
                  <td>
                    <ol>
                      <p>
                        <li value='2'>E-mailul de contact</li>
                      </p>
                    </ol>
                  </td>
                  <td>
                    Folosim, de asemenea, e-mailul de contact pentru contactarea
                    Utilizatorului si pentru transmiterea de mesaje de marketing
                    cu privire la website si serviciile noastre.
                  </td>
                </tr>
                <tr>
                  <td>
                    <ol>
                      <p>
                        <li value='3'>
                          Citate, imagini statice sau inregistrari audio-video
                          cu reprezentantii Utilizatorilor
                        </li>
                      </p>
                    </ol>
                  </td>
                  <td>
                    <p>
                      Testimoniale (marketingul si promovarea Software-ului)
                    </p>
                  </td>
                </tr>
              </table>
              <p>
                <li>
                  Utilizatorul este cel care furnizeaza datele personale de mai
                  sus catre Sirar, pe proprie raspundere, si garanteaza ca
                  asemenea date sunt transmise in baza consimtamantului
                  persoanei vizate sau a unui alt temei legitim, precum si ca a
                  informat in mod corespunzator persoana vizata cu privire la
                  aceasta prelucrare de date personale. In cazul in care acest
                  lucru este solicitat de catre Sirar, Utilizatorul va furniza
                  dovada scrisa a respectarii garantiilor din acest art. 22 al
                  Politicii.
                </li>
              </p>
            </ol>

            <i>IV.3. Durata stocarii</i>
            <ol>
              <p>
                <li value='24'>
                  Datele furnizate raman stocate electronic sau fizic pe
                  perioada existentei contului de utilizator si pentru o
                  perioada ulterioara de [3] ani, pentru scopuri de proba in
                  instanta, cu exceptia situatiei cand legislatia impune un
                  termen mai mare (ex: termen de arhivare impus de legislatia
                  contabila).{' '}
                </li>
              </p>
            </ol>
            <i>IV.4. Incetarea prelucrarilor pentru scopuri de marketing</i>
            <ol>
              <p>
                <li value='25'>
                  Cu privire la datelor folosite in scop de marketing, puteti la
                  orice moment sa ne solicitati stergerea acestora si incetarea
                  prelucrarii lor, contactandu-ne in acest sens.
                </li>
              </p>
              <p>
                <li>
                  De asemenea, va puteti dezabona - oricand si gratuit -
                  accesand link-ul de dezabonare situat in partea de jos a
                  fiecarui asemenea e-mail de marketing, cat si pe Website-ul
                  nostru. In cel mult 48 de ore, vom elimina adresa dvs. de
                  e-mail din lista noastra de e-mail marketing pentru newsletter
                </li>
              </p>
            </ol>
            <i>IV.5. Temeiul legal al prelucrarii </i>
            <ol>
              <p>
                <li value='27'>
                  Art. 6, lit. a) din GDPR – consimtamantul persoanei vizate. In
                  privinta testimonialelor, vi se va solicita acordul expres pe
                  e-mail inainte de postarea acestora pe website-ul Sirar sau in
                  alte materiale de marketing.
                </li>
              </p>
              <p>
                <li>
                  Art. 6, litera f) din GDPR - prelucrarea este necesara in
                  scopul intereselor legitime urmarite de operator. In mod
                  particular este vorba de transmiterea mesaje de marketing
                  privind operatorul, atunci cand transmiterea nu se intemeiaza
                  pe consimtamantul persoanei vizate, ci pe relatia contractuala
                  pre-existenta cu Utilizatorii.
                </li>
              </p>
            </ol>
            <i>
              IV.6. Catre cine putem transmite datele personale pe care le
              prelucram in calitate de Operator
            </i>
            <ol>
              <li value='29'>
                Angajatii, colaboratorii, consultantii nostri sau alte persoane
                autorizate, care au nevoie sa cunoasca aceste informatii.
                Fiecare asemenea persoana este supusa unei obligatii legale sau
                contractuale de confidentialitate;{' '}
              </li>
            </ol>
            <i>
              IV.7. Transfer international de date personale catre alte persoane
            </i>
            <p>
              Nu intentionam sa transferam datele dvs. personale in afara
              Uniunii Europene.
            </p>
            <i>IV.8. Inexistenta unui proces decizional automatizat </i>
            <p>
              Nu veti fi supus unei decizii bazate exclusiv pe prelucrarea
              automata a datelor dvs. cu caracter personal, cum ar fi
              profiling-ul.
            </p>
            <i>IV.9. Care sunt drepturile dvs. si cum le puteti exercita </i>
            <ol>
              <p>
                <li value='30'>
                  Ne angajam sa va respectam drepturile cu privire la datele
                  personale si informatiile pe care ni le furnizati{' '}
                </li>
              </p>
              <p>
                <li>Pe scurt, aveti urmatoarele drepturi:</li>
              </p>
              <p>
                <b>Dreptul la opozitie al Persoanei Vizate</b>
              </p>
              <p>
                Persoana Vizata are dreptul sa solicite incetarea oricarei
                prelucrari de DCP intemeiate pe interesul legitim sau pe
                interesul public, in anumite situatii (de exemplu: in cazul
                comunicarilor de marketing, dreptul la opozitie poate fi
                exercitat oricand si neconditionat). Totusi, nu intotdeauna o
                solicitare intemeiata pe dreptul de a obiecta la prelucrare va
                fi satisfacuta de Operator, daca Operatorul are motive legitime
                si imperioase care justifica prelucrarea si care prevaleaza
                asupra intereselor, drepturilor si libertatilor persoanei vizate
                sau in cazul in care scopul este constatarea, exercitarea sau
                apararea unui drept in instanta.{' '}
              </p>
              <p>
                <b>Dreptul de acces.</b> Persoanele vizate au dreptul la orice
                moment sa aiba acces la DCP pe care Operatorul le prelucreaza.
                In virtutea acestui drept, persoanele vizate au dreptul sa
                obtina informatii cu privire la aspecte precum: natura,
                prelucrarea si dezvaluirea acestor DCP catre terti. De asemenea,
                Persoanele vizate au dreptul sa obtina o copie a acestor date.
              </p>
              <p>
                <b>Dreptul la rectificare.</b> La cererea persoanelor vizate,
                Operatorul va rectifica orice eroare sau inexactitate privind
                DCP.{' '}
              </p>
              <p>
                “<b>Dreptul de a fi uitat</b>”. Persoanele vizate au dreptul sa
                solicite la orice moment stergerea DCP pe care Operatorul sau
                partenerii sai le prelucreaza pentru anumite motive (de exemplu:
                daca scopul prelucrarii DCP a fost indeplinit). Totusi, nu
                intotdeauna o solicitare intemeiata pe dreptul de a fi uitat va
                fi satisfacuta de Operator, de exemplu: daca DCP sunt necesare
                pentru apararea unui drept in justitie al Operatorului.{' '}
              </p>
              <p>
                <b>Dreptul de a restrictiona prelucrarea.</b> in anumite
                conditii prevazute de lege, Persoana Vizata are dreptul sa
                restrictioneze prelucrarea DCP (de exemplu: in situatia in care
                exactitatea sau corectitudinea DCP este contestata de Persoana
                Vizata). In asemenea situatii, prelucrarea nu va mai putea fi
                efectuata decat cu consimtamantul Persoanei Vizate, cu anumite
                exceptii (de exemplu: stocarea).
              </p>
              <p>
                <b>Dreptul la portabilitatea DCP.</b> In conditiile prevazute de
                Lege, Persoana Vizata are dreptul sa solicite ca DCP care o
                privesc si pe care le-a furnizat sa fie transmise intr-un format
                structurat, utilizat in mod curent si care poate fi citit
                automat; DCP astfel furnizate pot fi transmise catre alt
                Operator, la solicitarea persoanei vizate.
              </p>
              <p>
                <b>Dreptul de a retrage consimtamantul.</b> Atunci cand DCP sunt
                prelucrate pe baza consimtamantului Persoanei Vizate, se poate
                retrage acest consimtamant la orice moment. Aceasta nu va afecta
                prelucrarile efectuate in trecut, dar poate impiedica
                prelucrarea in viitor. In principiu, DCP de mai sus nu sunt
                prelucrate in temeiul consimtamantului persoanei vizate, dar
                este posibil ca pe viitor aceasta sa se intample, caz in care
                dreptul de retragere a consimtamantul devine aplicabil.
              </p>
              <p>
                <b>Dreptul de a se adresa autoritatii de supraveghere.</b>{' '}
                Pentru prelucrarile care intra in competenta autoritatilor
                romane, Persoana Vizata poate adresa o plangere catre
                Autoritatea Nationala de Supraveghere a Prelucrarii Datelor cu
                Caracter Personal (
                <a href='http://www.dataprotection.ro'>
                  http://www.dataprotection.ro
                </a>
                ).
              </p>
              <p>
                <li>
                  In vederea exercitarii oricarui drept din cele mentionate mai
                  sus, precum si pentru a pune orice intrebare cu privire
                  aceasta Politica de confidentialitate, ne puteti contacta,
                  folosind datele de contact de mai sus.
                </li>
              </p>
            </ol>
            <i>IV.10. Alte informatii</i>
            <ol>
              <li value='33'>
                <p>
                  Ce se intampla daca refuzati sa ne furnizati datele personale{' '}
                </p>
                <p>
                  Nu sunteti obligat sa ne furnizati datele dvs. personale, cu
                  toate acestea, refuzul de a furniza informatiile necesare
                  pentru crearea contului de utilizator va face imposibila
                  utilizarea Software-ului. Ne straduim sa pastram aceste
                  informatii la minimul necesar, astfel incat sa va respectam
                  viata privata.
                </p>
              </li>
              <li>
                <p>Modificari ale Politicii de confidentialitate</p>
                <p>
                  Din timp in timp, este posibil sa modificam aceasta Politica
                  de confidentialitate pentru a reflecta schimbarile legislative
                  sau modificarile politicilor noastre interne, ale website-ului
                  sau ale tehnologiei pe care o folosim. Cand reveniti, va rugam
                  sa verificati versiunea/data Politicii de confidentialitate
                  aplicabile si eventualele amendamente survenite.{' '}
                </p>
              </li>
              <li>
                <p>Documente coroborate</p>
                <p>
                  Aceasta Politica de confidentialitate, impreuna cu Contractul
                  de furnizare a Software-ului, Politica de module cookies
                  (link) si Termenii de utilizare a website-ului (link)
                  reprezinta contractul dvs. cu noi. Acest contract
                  reglementeaza utilizarea Software-ului, de aceea va incurajam
                  cititi documentele de mai sus cu atentie, coroborandu-le.
                </p>
              </li>
              <li>
                <p>Linkuri catre alte website-uri</p>
                <p>
                  Acest website poate contine linkuri catre alte website-uri
                  terte (care la randu-le pot colecta si prelucra datele dvs.
                  personale). Prin accesarea acestor linkuri, veti deveni
                  subiectul practicilor si politicilor respectivelor website-uri
                  terte. Societatea nu isi asuma si nu poate fi tinut
                  responsabil pentru asemenea practici sau politici ale acestor
                  website-uri.{' '}
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
